import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "28",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23.088 0h-9.094l2.81 8.758h9.094l-7.357 5.223 2.811 8.807c4.736-3.45 6.283-8.67 4.547-14.03zM2.09 8.758h9.093L13.994 0H4.902zc-1.737 5.36-.19 10.58 4.546 14.03l2.81-8.808zm4.546 14.03L13.994 28l7.358-5.212-7.358-5.298z"
    }, null, -1)
  ]))]))
}
export default { render: render }